<template>
    <transition name="fade">
        <p v-if="show" class="text-success mt-3">
            <slot></slot>
        </p>
    </transition>
</template>

<script>
    export default {
        props: ['show']
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s .7S
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>